import { atom } from 'jotai';

export const isScheduleDrawerOpenAtom = atom<boolean>(false);

export const isOpenScheduleDialogAtom = atom<boolean>(false);
export const editScheduleItemAtom = atom<string | null>(null);

export const isOpenDeleteDialogAtom = atom<boolean>(false);
export const deleteScheduledQueryIdsAtom = atom<string[] | null>(null);
